import { render, staticRenderFns } from "./Profiel.vue?vue&type=template&id=d469d35a&"
import script from "./Profiel.vue?vue&type=script&lang=js&"
export * from "./Profiel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d469d35a')) {
      api.createRecord('d469d35a', component.options)
    } else {
      api.reload('d469d35a', component.options)
    }
    module.hot.accept("./Profiel.vue?vue&type=template&id=d469d35a&", function () {
      api.rerender('d469d35a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Profiel.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Profiel.vue
// module id = 432
// module chunks = 0